<script setup>
const props = defineProps({
  productTypes:{
    type: Array,
    default: ()=> [],
  },
  length:{
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="flex flex-row gap-2">
    <div
      v-if="productTypes.includes('VIDEO')"
      class="text-xs border border-blueLight-200 bg-blueLight-50 text-blueLight-700 rounded-md px-1.5 py-0.5">
      Video
    </div>

    <div
      v-if="productTypes.includes('WEBINAR')"
      class="text-xs border border-purple-200 bg-purple-50 text-purple-700 rounded-md px-1.5 py-0.5">
      Webinar
    </div>

    <div
      v-if="productTypes.includes('LIVESTREAM')"
      class="text-xs border border-orange-200 bg-orange-50 text-orange-700 rounded-md px-1.5 py-0.5">
      Live Stream
    </div>

    <div
      v-if="productTypes.includes('TEXT')"
      class="text-xs border border-blue-200 bg-blue-50 text-blue-600 rounded-md px-1.5 py-0.5">
      Text
    </div>

    <div
      v-if="productTypes.includes('LIVE')"
      class="text-xs border border-indigo-200 bg-indigo-50 text-indigo-700 rounded-md px-1.5 py-0.5">
      In-Person
    </div>

    <div
      v-if="productTypes.includes('PODCAST')"
      class="text-xs border border-pink-200 bg-pink-50 text-pink-700 rounded-md px-1.5 py-0.5">
      Podcast
    </div>

    <div
      v-if="length !== ''"
      class="text-xs border border-green-200 bg-green-50 text-green-700 rounded-md px-1.5 py-0.5">
      {{length}} Hours
    </div>
  </div>
</template>

